import { combineReducers, configureStore } from '@reduxjs/toolkit';
import * as lmsServiceApis from '../../Apis/LMSService';
import * as clientApis from '../../Apis/Client';
// import * as messageApis from '../../Apis/Messages';
import * as anonymousApis from '../../Apis/Anonymous';
import * as commonApis from '../../Apis/Common';
import { mutationMiddleware } from './middleware';
import { createMiddleware, createRootReducer } from './utils';

import {
  createCourseSlice,
  createPackageSlice,
  createWhatsAppSlice,
  resetUserReducer,
  routesReducer,
  themeConfigSlice,
  userAuthReducer,
  whatsAppTreeSlice,
  bookReducer,
  upsertTicketSlice,
  errorBoundaryCounterReducer,
  encryptedVideoSlice,
  courseBuilderSlice,
  examSetSlice,
  storageSlice,
  notificationformSlice,
  MCQSetSlice,
  demoVideoSetSlice,
  dashboardSlice,
} from './slice';
import baseApi from '../../Apis/baseApi';

const apiReducers = createRootReducer({
  ...lmsServiceApis,
  ...clientApis,
  // ...messageApis,
  ...anonymousApis,
  ...commonApis,
});

const rootReducer = combineReducers({
  themeConfig: themeConfigSlice,
  bookReducer: bookReducer,
  examSetSlice: examSetSlice,
  MCQSetSlice: MCQSetSlice,
  notificationformSlice: notificationformSlice,
  demoVideoSetSlice: demoVideoSetSlice,
  upsertTicket: upsertTicketSlice,
  userAuthStore: userAuthReducer,
  routesStore: routesReducer,
  restUserStore: resetUserReducer,
  course: createCourseSlice,
  whatsAppTree: whatsAppTreeSlice,
  whatsApp: createWhatsAppSlice,
  package: createPackageSlice,
  errorBoundaryCounterReducer: errorBoundaryCounterReducer,
  encryptedVideo: encryptedVideoSlice,
  courseBuilder: courseBuilderSlice,
  storage: storageSlice,
  dashboardSlice: dashboardSlice,
  [baseApi.reducerPath]: baseApi.reducer,
  ...apiReducers,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
      .concat(baseApi.middleware)
      .concat(
        ...createMiddleware(
          {
            ...lmsServiceApis,
            ...clientApis,
            // ...messageApis,
            ...anonymousApis,
            ...commonApis,
          },
          mutationMiddleware
        )
      ),
  //.concat(infiniteLoopDetector),
  // devTools: true,
});

export type IRootState = ReturnType<typeof rootReducer>;
export default store;
